import role, { getUid } from './role'

export * from './utils'

export * from './role'

export * from './filter'
// 封装自定义参数 用于 fetch 请求添加
let sessionId = localStorage.getItem('currentUserToken')
let accessIp = localStorage.getItem('accessIp')
let userId = getUid()
export const customCookie = `sessionId=${sessionId};ip=${accessIp};userId=${userId}`

export { role }



// WEBPACK FOOTER //
// ./src/lib/index.js